import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { CONSTANT, GridDataSource, LoaderService, NotificationService } from 'src/app/shared/session';
import { ZonaRegionService } from '../shared/zona-region.service';

@Component({
  selector: 'app-zona-region-list',
  templateUrl: './zona-region-list.component.html',
})
export class ZonaRegionListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() titlePage: string;
  @Input() data: any;
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;

  pageSize: number;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(
    private loaderService: LoaderService,
    private zonaRegionService: ZonaRegionService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.msgErrorGet = 'Error al listar las Regiones';
    this.displayedColumns = ['Relacionado', 'Region'];
  }

  searchEmit(data: any) {
    this.buscarZonaRegion(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  buscarZonaRegion(filtro: string) {
    this.listarZonaRegion(filtro);
  }

  listarZonaRegion(filtro: string) {
    this.loaderService.show();
    this.zonaRegionService.listarZonaRegion(filtro, this.data.zona.id)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  onChangeVinculacion(row: any) {
    this.guardarZonaRegion(row.idRegion)
  }

  guardarZonaRegion(idRegion: number): void {
    this.loaderService.show();
    this.zonaRegionService.guardarZonaRegion(this.data.zona.id, idRegion)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
